export default {
    role(state) {
        return (state.user && state.user.role) ? state.user.role : null
    },
    roleObj(state, getters, rootState) {
        if (state.user && state.user.role) {
            return rootState.users.roles.find((e) => e.value == state.user.role)
        }
        return {
            text: 'Sin especificar',
            value: 'sin_especificar'
        };
    },
    informeDescargar(state) {
        //if (state.user.descargas)
    },
    mensajesSinLeer(state) {
        var count = 0;
        state.mensajes.forEach((e) => {
            if (!e.leido)
                count++
        })
        return count;
    },
    isAdmin(state, getters) {
        return getters.role == 'admin';
    },
    perfilUsuario(state, getters, rootState) {
        let user = state.user;
        const found = rootState.users.roles.find(e => e.value == user.role);
        let roleObj = {
            text: 'Sin asignar',
            value: null
        }
        if (found) {
            roleObj = {
                text: found.text,
                value: found.value
            }
        }
        return {
            nombre: (user.nombre) ? user.nombre : user.displayName,
            apellidos: (user.apellidos) ? user.apellidos : '',
            email: user.email,
            role: roleObj
        }
    }
}